export const ACADEMIC_DISCIPLINE_RADIO_OPTIONS = {
  ALL: 'include-all',
  SOME: 'select',
  NONE: 'none',
};

export enum ModalStates {
  AddError = 'ADD_ERROR',
  DuplicateDomainNames = 'DUPLICATE_DOMAIN_NAMES',
  DeleteConfirm = 'DELETE_CONFIRM',
  DeleteSuccess = 'DELETE_SUCCESS',
  DeleteError = 'DELETE_ERROR',
}
